import { render, staticRenderFns } from "./conversation-detail.vue?vue&type=template&id=42f06df0&scoped=true&"
import script from "./conversation-detail.vue?vue&type=script&lang=js&"
export * from "./conversation-detail.vue?vue&type=script&lang=js&"
import style0 from "./conversation-detail.vue?vue&type=style&index=0&id=42f06df0&scoped=true&lang=css&"
import style1 from "./conversation-detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f06df0",
  null
  
)

export default component.exports